import { render } from "./VPanel.vue?vue&type=template&id=f982a804"
import script from "./VPanel.vue?vue&type=script&lang=js"
export * from "./VPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__